import { forwardRef } from 'react';
import PaymentezPaymentTypeButton from './PaymentezPaymentTypeButton';

function PaymentezPaymentDeferredNoInterestButton({ innerRef }) {
  return (
    <PaymentezPaymentTypeButton
      label="Pago diferido"
      description="Realiza el pago diferido con intereses del valor de tu compra."
      ref={innerRef}
    />
  );
}

const PaymentezPaymentDeferredNoInterestButtonContainer = forwardRef(
  (props, ref) => (
    <PaymentezPaymentDeferredNoInterestButton innerRef={ref} {...props} />
  )
);

PaymentezPaymentDeferredNoInterestButtonContainer.displayName =
  'PaymentezPaymentDeferredNoInterestButtonContainer';

export default PaymentezPaymentDeferredNoInterestButtonContainer;
